var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"container py-5",attrs:{"role":"main"}},[_c('b-button',{on:{"click":_vm.onClickTest}},[_vm._v("Test loading modal")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }